"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UawBase;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _universalAdWidget = require("@ux-dri/universal-ad-widget");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const UniversalAdWidgetContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "UniversalAdWidgetContainer",
  class: "pl-unszqyi"
});
function UawBase({
  adPlacementKey,
  universalAdWidgetConfig,
  maxAdsToDisplay = 10
}) {
  const [adsResponse, setAdsResponse] = (0, _react.useState)();
  const [adsLoading, setAdsLoading] = (0, _react.useState)(true);

  // TODO how do we connect to hivemind to get omsId?
  const omsId = 'baseline';
  const presentationStrategy = {
    name: 'NATIVE_PLACEMENT_V2',
    resolveLayoutStrategy: () => {
      return {
        Component: _universalAdWidget.NativePlacementV2
      };
    },
    supportedKevelAdType: _universalAdWidget.KevelAdType.NativeAdV1
  };
  maxAdsToDisplay = universalAdWidgetConfig?.placements[adPlacementKey]?.kevelPlacementConfig.count || maxAdsToDisplay;
  (0, _react.useEffect)(() => {
    (0, _universalAdWidget.fetchAds)({
      adPlacementKey,
      universalAdWidgetConfig,
      omsId,
      presentationStrategy,
      setAdsResponse,
      setAdsLoading
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react.default.createElement(UniversalAdWidgetContainer, null, /*#__PURE__*/_react.default.createElement(_universalAdWidget.UniversalAdWidget, (0, _extends2.default)({
    maxAdsToDisplay: maxAdsToDisplay,
    loading: adsLoading,
    presentationStrategy: presentationStrategy
  }, adsResponse)));
}
UawBase.propTypes = {
  adPlacementKey: _propTypes.default.string.isRequired,
  universalAdWidgetConfig: _propTypes.default.object.isRequired,
  maxAdsToDisplay: _propTypes.default.number
};